/* eslint no-console:0 */
import 'bootstrap'
import '../src/application.scss'

// Rails UJS
import Rails from '@rails/ujs'

require.context('../images', true, /\.(svg|png|gif|jpg|jpeg|ico)$/)

// Galette design-system icons, consumed from the npm package and emitted under
// the `static/svg/*` logical path (resolved via shakapacker additional_paths).
// Used app-wide by UI::IconComponent; emitted here alongside the other images
// since all packs share one compiled manifest. The path is relative (rather than
// a bare package request) to reach the directory directly — the package's
// `exports` map only defines the `./icons/svg/*` file pattern, not the directory.
require.context('../../../node_modules/@mes-amis/galette-design-system/icons/svg', false, /\.svg$/)

Rails.start()
